/**
 * Share Context
 *
 * Manages magic link state for unauthenticated dashboard access
 * Uses JWT token generated from magic link validation
 */

import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { ShareContext as ShareContextType } from "@/lib/types/share";

const ShareContext = createContext<ShareContextType | undefined>(undefined);

export function ShareProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: ShareContextType;
}) {
  return (
    <ShareContext.Provider value={value}>{children}</ShareContext.Provider>
  );
}

export function useShare() {
  const context = useContext(ShareContext);
  if (!context) {
    throw new Error("useShare must be used within ShareProvider");
  }
  return context;
}
